










import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class ExplainFooter extends Vue {
    @Prop() data!: string[]
}
